import Vue from "vue";
import moment from "moment";
import { Component, Prop } from "vue-property-decorator";
import { getBrowserDateFormat } from "../../utils/date-helper";

@Component({
  template: require("./template.html")
})
class LabelDateTimeFormattedComponent extends Vue {
  @Prop({ default: "date" })
  type: string;

  @Prop({ default: null })
  format: string;

  @Prop({ required: true, type:[Object, Array, String]})
  value;

  _value: Date;
  _format: string;

  get FormattedDate() {
    // FRO-10891: default to the browser-locale numeric format unless an explicit one is given.
    this._format = this.format ? this.format : getBrowserDateFormat();

    if (this.value ===  undefined || this.value === null) {
       return "";
    }
    else if (typeof this.value === "string") {
      this._value = moment(this.value).toDate();
    } else {
      this._value = this.value;
    }

    return moment(this._value).format(this._format);
  }

  beforeDestroy(){
    this._value = null;
    this._format = null;
  }
}

export default LabelDateTimeFormattedComponent;
